export class EventCaseField {
  case_field_id: string;
  showCondition: string;
}
